module.exports = __webpack_public_path__ + "img/3화_13-2.907f89ba.png";